import { Injectable } from '@angular/core';
import { UrlService } from '../url/url.service';

@Injectable()
export class TranslationService {
    public _translations = new Map();

    private _disabled = false;

    public constructor(private _urlService: UrlService) {}

    public enable() {
        this._disabled = false;
    }

    public disable() {
        this._disabled = true;
    }

    public addTranslation(key: string, translation: string) {
        this._translations[`${key}`] = translation;
    }

    public getTranslation(key: string): string {
        const _showTranslation = !this._disabled || (this._disabled && !this._urlService.getQueryParam('disabletranslation'));
        return _showTranslation ? this._translations[`${key}`] : key;
    }

    public getAllTranslations(prefix: string): { [key: string]: string } {
        const _searchPrefix = prefix.toLocaleLowerCase();
        const _ret: { [key: string]: string } = {};
        const _showTranslation = !this._disabled || (this._disabled && !this._urlService.getQueryParam('disabletranslation'));

        for (const _key in this._translations) {
            if (_key.match(`^${_searchPrefix}-`)) {
                const _propertyKey = _key.replace(`${_searchPrefix}-`, '');
                _ret[_propertyKey] = _showTranslation ? this._translations[`${_key}`] : _key;
            }
        }
        return _ret;
    }

    public getAllOriginalTranslations(prefix: string): { [key: string]: string } {
        const _searchPrefix = prefix;
        const _ret: { [key: string]: string } = {};
        const _showTranslation = !this._disabled || (this._disabled && !this._urlService.getQueryParam('disabletranslation'));

        for (const _key in this._translations) {
            if (_key.match(`^${_searchPrefix}-`)) {
                const _propertyKey = _key.replace(`${_searchPrefix}-`, '');
                _ret[_propertyKey] = _showTranslation ? this._translations[`${_key}`] : _key;
            }
        }
        return _ret;
    }
}
